import React from 'react'
import { LABELS, SOCIAL_NETWORKS } from '../constants/staticText'

// Netzwerk-Adressen der Anzeige. Sie werden im Backoffice gepflegt und standen
// bisher auf keiner Seite (#53). Ueber SOCIAL_NETWORKS gesteuert, damit ein
// weiteres Netz eine Zeile Text ist und keine neue Komponente.
const JobSocial = ({ social }) => {
    const gepflegt = SOCIAL_NETWORKS.filter(network => social[network.key])

    if (0 === gepflegt.length) return null

    return (
        <section className="job-detail-social">
            <h2>{LABELS.socialHeading}</h2>
            <ul>
                {gepflegt.map(network => (
                    <li key={network.key} className={`job-detail-social-${network.key}`}>
                        <a href={social[network.key]} target="_blank" rel="noreferrer">{network.name}</a>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default JobSocial
